export const METAFIELDS_ORDERS_URL = '/v1/metafields/orders';
export const METAFIELDS_VARIANTS_URL = '/v1/metafields/product_variants';
export const METAFIELDS_CUSTOMERS_URL = '/v1/metafields/customers';
export const METAFIELDS_CATEGORIES_URL = '/v1/metafields/categories';
export const METAFIELDS_PRODUCTS_AND_VARIANTS_URL =
  '/v1/metafields/product_and_variants';
